import React, { Fragment, useEffect, useState } from 'react';
import { Card, CardBody, Col, ListGroup, ListGroupItem, Row } from 'reactstrap';
import ConversionGraph from '../../pages/conversions/ConversionGraph';

const BarGraph = ({ dataOptions,title,payload,properties }) => {

    const dataPoints = {};
    dataOptions.forEach(val => {
        dataPoints[val.value==='unis'? 'units':val.value] = val.label;
        // dataPoints[val.value] = val.label;
    });
    const [sortBy, setSortBy] = useState(Object.keys(dataPoints)[0]);
    const selectedArray = [sortBy]
    return (
        <Fragment>
            <Card style={{ minHeight: '6.75rem', maxheight: "20rem"}}>
                <CardBody>
                    <Row>
                        <Col sm={2} md={2} className='border-right-1'>
                            <h4 className='filter-heading'>View By</h4>
                            <ListGroup flush>
                                {
                                    Object.keys(dataPoints).map((key, index) => {
                                        return (
                                            <ListGroupItem tag="li" onClick={() => setSortBy(key)} key={"selected-data-point-" + index} className={'w-100 data-point-card pointer ' + (sortBy == key ? 'active' : '')}>
                                                {dataPoints[key]}
                                            </ListGroupItem>
                                        )
                                    })
                                }
                            </ListGroup>
                        </Col>
                        <Col md={10} sm={12}>
                            <Row>
                                <ConversionGraph title={title} payload={payload} properties={selectedArray} />
                            </Row>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default BarGraph;